<template>
  <v-form ref="form">
    <v-row>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formSite.name') }}</v-col>
          <v-col cols="auto">
            <div class="is-clickable" @click="deleteForm">
              <v-icon color="error">mdi-minus-circle</v-icon>
            </div>
          </v-col>
        </v-row>
        <v-text-field :value="data.name" @input="value=>updateForm('name', value)" :label="$t('formSite.name')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formSite.location') }}</v-col>
          <v-col cols="auto">
            <v-chip class="ma-2 is-clickable" small="small" color="secondary">{{ $t('formSite.pin') }}</v-chip>
            <v-chip class="ma-2 is-clickable" small="small" color="secondary">{{ $t('formSite.currentLocation') }}</v-chip>
            <v-chip class="ma-2 is-clickable" small="small" color="secondary">{{ $t('formSite.typeLocation') }}</v-chip>
          </v-col>
        </v-row>
        <v-text-field :value="data.position" @input="value=>updateForm('position', value)" :label="$t('formSite.location')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formSite.bikeRacks') }}</v-col>
        </v-row>
        <v-text-field :value="data.bikeRacks" @input="value=>updateForm('bikeRacks', value)" type="number" :label="$t('formSite.bikeRacks')" solo="solo" flat="flat" outlined="outlined"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formSite.startDate') }}</v-col>
        </v-row>
        <v-text-field :value="data.startDate" @input="value=>updateForm('startDate', value)" :label="$t('formSite.startDate')" solo="solo" flat="flat" outlined="outlined"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    deleteForm () {
      this.$emit('delete', this.data.id)
    },
    updateForm (field, value) {
      this.$emit('update', { data: this.data.id, field, value })
    }
  }
}
</script>
